angular.module( 'acme.view.application.templates.modals.discount', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.templates.modals.discount.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var templatesModalsDiscount = {
        name: 'application.templates.modals.discount',
        url: '/templates/modals/discount',
        views: {
          "main": {
            controller: 'TemplatesModalsDiscountController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/templates/modals/discount/discount.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(templatesModalsDiscount);
});
